import { Immutable } from "immer";
import React from "react";
import { ProductCompareGridSSR } from "tsi-common-react/src/apps/product-compare/ProductCompareGridSSR/index";
import { LimitedTimeOfferGridBlock } from "tsi-common-react/src/components/LimitedTimeOfferGridBlock/index";

import { templates } from "@reactivated";

import { EverydayOfferGridBlock } from "./EverydayOfferGridBlock";
import { HeroImageBlock } from "./HeroImageBlock";
import { OfferBannerBlock } from "./OfferBannerBlock";

/**
 * Block dispatcher map for the ``OfferIndexPage`` body assembly
 * (``OfferIndexPageBody``). Keys are the EXACT block-name strings from
 * the Python ``OfferContent`` StreamBlock
 * (``server/cms/pages/offer_index_page.py``):
 *   - ``limited_time_grid``    -> LimitedTimeOfferGridBlock (shared, takes value)
 *   - ``everyday_grid``        -> EverydayOfferGridBlock    (stearns, takes value)
 *   - ``banner``               -> OfferBannerBlock          (stearns, takes value)
 *   - ``hero``                 -> HeroImageBlock            (stearns, takes value)
 *   - ``product_compare_grid`` -> ProductCompareGridSSR     (SSR-envelope value)
 *
 * The four offer components each accept a plain ``value`` prop, so they dispatch
 * directly. ``product_compare_grid`` mirrors the toolbox map's entry: its
 * ``block.value`` carries the full server-computed SSR envelope (matching
 * ``templates.ProductCompareGridBlockTemplate``), spread into
 * ``ProductCompareGridSSR`` with ``showFirstAvailablePrice`` + ``isMinimal`` (as
 * the stearns ``ProductCompareGridBlockTemplate.tsx`` does).
 */
export const offerContentComponentsMap = {
    limited_time_grid: LimitedTimeOfferGridBlock,
    everyday_grid: EverydayOfferGridBlock,
    banner: OfferBannerBlock,
    hero: HeroImageBlock,
    product_compare_grid: (block: {
        value: Immutable<templates.ProductCompareGridBlockTemplate> | null;
    }) =>
        block.value ? (
            <ProductCompareGridSSR
                {...block.value}
                showFirstAvailablePrice
                isMinimal
            />
        ) : null,
} as const;
